// extracted by mini-css-extract-plugin
export default {"errorBoundary":"h43Pwg","title":"XEHVkq"};